export default __webpack_public_path__ + "static/media/1.604df38d.png";